export function getCertificateDownloadUrl(proxyPath: string, fileUrl: string) {
  const certificateUrl = new URL(fileUrl)
  const certificatePram = `${certificateUrl.hostname}${certificateUrl.pathname}`

  const downloadUrl = new URL(proxyPath, window.location.href)
  downloadUrl.searchParams.set('url', certificatePram)

  return downloadUrl.toString()
}
